<template>
	<svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" @click="on_click()">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M1.80566 9.99984C1.80566 5.39984 5.85011 1.6665 10.8334 1.6665C15.8168 1.6665 19.8612 5.39984 19.8612 9.99984C19.8612 14.5998 15.8168 18.3332 10.8334 18.3332C5.85011 18.3332 1.80566 14.5998 1.80566 9.99984ZM3.61122 9.99984C3.61122 13.6748 6.85219 16.6665 10.8334 16.6665C14.8147 16.6665 18.0557 13.6748 18.0557 9.99984C18.0557 6.32484 14.8147 3.33317 10.8334 3.33317C6.85219 3.33317 3.61122 6.32484 3.61122 9.99984Z" :fill="fill_color" :fill-opacity="opacity"/>
		<path d="M14.9772 6.31689L9.02786 11.8086L6.68966 9.65856L5.41675 10.8336L9.02786 14.1669L16.2501 7.50023L14.9772 6.31689Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>